@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

.TableLegend {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-l ;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border: solid 1px Colors.$col-design-grey14;
	border-bottom: none;
	font-size: Constants.$val-fontSizeRegular;

	.rateItem {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-right: Constants.$val-spacing-l;

		.rateSource {
			margin-right: Constants.$val-spacing-xs;
		}
	}

	.followingDayDisclaimer {
		color: Colors.$col-design-grey10;
		font-style: italic;
	}
}
